/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';
import _ from 'lodash';
import pluralize from 'pluralize';
import forms from 'newforms';
import urlResolver from 'edrolo/utils/URLResolver';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

const FormRow = forms.FormRow;

const TeacherCommentForm = forms.Form.extend({
  comment_from_teacher: forms.CharField({
    widget: forms.Textarea({
      attrs: {
        className: 'form-control',
        placeholder: 'Add a comment (optional)',
        rows: '2',
      },
    }),
    required: false,
  }),
  student: forms.CharField({ widget: forms.HiddenInput() }),
  question: forms.CharField({ widget: forms.HiddenInput() }),
  sitting: forms.CharField({ widget: forms.HiddenInput() }),
});

const TeacherMarkingForm = forms.Form.extend({
  // This is not fair. I can't extend TeacherComment form and put
  // text_marks_from_teacher at the top of the list!
  text_marks_from_teacher: forms.DecimalField({
    minValue: 0,
    maxDigits: 2,
    decimalPlaces: 0,
    widget: forms.TextInput({
      attrs: {
        className: 'form-control',
      },
    }),
    required: false,
  }),

  comment_from_teacher: forms.CharField({
    widget: forms.Textarea({
      attrs: {
        className: 'form-control',
        placeholder: 'Add a comment (optional)',
        rows: '2',
      },
    }),
    required: false,
  }),

  student: forms.CharField({ widget: forms.HiddenInput() }),
  question: forms.CharField({ widget: forms.HiddenInput() }),
  sitting: forms.CharField({ widget: forms.HiddenInput() }),
});

class TeacherFeedbackForm extends Component {
  static defaultProps = {
    data: {},
    onCancel() {},
    onChange() {},
  };

  constructor(props) {
    super(props);
    const FormClass =
      {
        [EXAM_QUESTION_TYPES.SINGLE_ANSWER_MULTI_CHOICE]: TeacherCommentForm,
        [EXAM_QUESTION_TYPES.TEXT]: TeacherMarkingForm,
        [EXAM_QUESTION_TYPES.WORKED]: TeacherMarkingForm,
        [EXAM_QUESTION_TYPES.COMPLEX]: TeacherMarkingForm,
      }[props.data.questionType] || TeacherCommentForm;

    this.state = {
      form: new FormClass({
        initial: props.data,
      }),
    };
  }

  handleCancel = (e) => {
    e.preventDefault();
    this.props.onCancel();
  };

  handleSave = (e) => {
    e.preventDefault();
    const form = this.state.form;
    const isValid = form.validate();
    if (isValid) {
      const url = urlResolver.reverse('api:post:exam-questions-feedback', {
        questionId: this.props.data.question,
      });
      const data = form.cleanedData;
      // Hack to workaround bug in newforms v0.10
      // Remove on upgrade to newforms v0.11+
      if (form.data.text_marks_from_student === '0') {
        data.text_marks_from_student = 0;
      }
      $.ajax({
        url,
        dataType: 'json',
        // contentType: 'application/json; charset=utf-8',
        type: 'POST',
        data, // JSON.stringify(data),
        success: function (outData) {
          this.props.onChange(outData);

          analytics.track('acted on student exam question response', {
            origin: this.props.origin,
            response_id: outData.id,
            class_id: this.props.data.school_class,
            course_id: this.props.data.course,
            calendar_year: this.props.data.calendar_year,
            sitting_id: this.props.data.sitting,
            has_comment: !_.isEmpty(outData.comment_from_teacher),
            has_mark: !_.isEmpty(outData.text_marks_from_teacher),
          });
        }.bind(this),
        error: (xhr, status, err) => {
          this.props.onCancel();
        },
      });
    } else {
      // console.log('it is not valid');
    }
  };

  renderField = (bf) => {
    if (bf.name == 'text_marks_from_teacher') {
      return (
        <div className="input-group" key="text_marks_from_teacher">
          {bf.render()}
          {/* <input className="form-control" value="2" /> */}
          <span className="input-group-addon">
            {`/ ${pluralize(
              'marks',
              Math.round10(this.props.data.maxMarks, 0),
              true
            )}`}
          </span>
          {bf.errors().render()}
        </div>
      );
    } else if (bf.isHidden()) {
      return <div key={bf.htmlName}>{bf.render()}</div>;
    }
    return (
      <div key={bf.htmlName}>
        <FormRow bf={bf} />
      </div>
    );
  };

  render() {
    return (
      <form onSubmit={this.handleSave}>
        {this.state.form.boundFields().map(this.renderField)}
        <button
          className="save-note btn btn-primary"
          name="action"
          onClick={this.handleSave}
        >
          Save
        </button>
        <button
          onClick={this.handleCancel}
          className="hide-note btn-link"
          type="button"
          name="cancel"
        >
          Cancel
        </button>
      </form>
    );
  }
}

export default TeacherFeedbackForm;
